import React from "react";

const SiteContainerPane: React.FC = (props) => (
    <React.Fragment>
      {props.children}
    </React.Fragment>
);

export default SiteContainerPane;
